import { render, staticRenderFns } from "./ConsumerFreshdeskWidget.vue?vue&type=template&id=2f1d13f8"
import script from "./ConsumerFreshdeskWidget.vue?vue&type=script&lang=js"
export * from "./ConsumerFreshdeskWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports